import React, { FC } from 'react';

import { EvSkeleton } from '@evinced-private/ui-common';

import './AccessibilitySummarySkeleton.scss';

interface AccessibilitySummarySkeletonProps {
	animationSpeed?: number;
}

export const AccessibilitySummarySkeleton: FC<AccessibilitySummarySkeletonProps> = ({
	animationSpeed
}) => {
	return (
		<div className="accessibility-summary-skeleton">
			<EvSkeleton height="135px" width="225px" animationSpeed={animationSpeed} />
			<div className="skeleton-metric-divider" aria-hidden="true" />
			<div className="skeleton-metric-group">
				<EvSkeleton height="135px" width="220px" animationSpeed={animationSpeed} />
				<EvSkeleton height="135px" width="220px" animationSpeed={animationSpeed} />
			</div>
			<div className="skeleton-metric-divider" aria-hidden="true" />
			<div className="skeleton-metric-group">
				<EvSkeleton height="135px" width="220px" animationSpeed={animationSpeed} />
				<EvSkeleton height="135px" width="220px" animationSpeed={animationSpeed} />
			</div>
		</div>
	);
};
